import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001';

interface ReleaseVersionData {
  currentVersion: string;
  releaseTitle: string;
  deployedAtUtc: string | null;
  gitCommitHash: string | null;
  environment: string;
  healthStatus: string;
  backendBuild: string | null;
  frontendBuild: string | null;
}

async function fetchAppVersion(): Promise<ReleaseVersionData> {
  const { data } = await axios.get(`${API_BASE_URL}/shared/release/version`);
  if (data.success && data.data) {
    return data.data;
  }
  throw new Error(data.message || 'Failed to fetch version');
}

export function useAppVersion() {
  const fallbackVersion = import.meta.env.VITE_APP_VERSION || '2.2.0015';

  const { data, isLoading, isError } = useQuery({
    queryKey: ['app-version'],
    queryFn: fetchAppVersion,
    staleTime: 5 * 60 * 1000,  // 5 minutes
    gcTime: 10 * 60 * 1000,    // 10 minutes
    retry: 1,
    refetchOnWindowFocus: false,
  });

  return {
    version: data?.currentVersion ?? fallbackVersion,
    releaseTitle: data?.releaseTitle ?? `EPPREM ${fallbackVersion}`,
    deployedAt: data?.deployedAtUtc ?? null,
    environment: data?.environment ?? 'Unknown',
    isLoading,
    isError,
  };
}
